import { Injectable, Injector } from "@angular/core";
import { ContractIntervalEnum } from "@enums/contractInterval.enum";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class ContractService extends Service {
	constructor(injector: Injector) {
		super("Contract", injector);
	}

	// API
	calculateIntervalCount(startDate: Date, endDate: Date, interval: ContractIntervalEnum) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/CalculateIntervalCount/${startDate.toDateString()}/${endDate.toDateString()}/${interval}`);
	}

	getBySupplierId(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForSupplier/${id}`);
	}
}